import type { TrackerSDK } from './types';

const getTargetSDKs = (): TrackerSDK[] => {
  const coralogix = window.coralogixLogger as TrackerSDK | undefined;

  return coralogix ? [coralogix] : [];
};

type CaptureExceptionArgs = Parameters<TrackerSDK['captureException']>;
type CaptureErrorArgs = Parameters<TrackerSDK['captureError']>;
type CaptureEventArgs = Parameters<TrackerSDK['captureEvent']>;
type CaptureMessageArgs = Parameters<TrackerSDK['captureMessage']>;

const captureException = (
  error: CaptureExceptionArgs[0],
  context?: CaptureExceptionArgs[1],
  labels?: CaptureExceptionArgs[2]
) => {
  getTargetSDKs().forEach((sdk) => {
    sdk?.captureException(error, context, labels);
  });
};

const captureError = (
  message: CaptureErrorArgs[0],
  context?: CaptureErrorArgs[1],
  labels?: CaptureErrorArgs[2]
) => {
  getTargetSDKs().forEach((sdk) => sdk?.captureError(message, context, labels));
};

const captureEvent = (event: CaptureEventArgs[0]) => {
  getTargetSDKs().forEach((sdk) => {
    sdk?.captureEvent(event);
  });
};

const captureMessage = (message: CaptureMessageArgs[0], context?: CaptureMessageArgs[1]) => {
  getTargetSDKs().forEach((sdk) => sdk?.captureMessage(message, context));
};

export { captureException, captureEvent, captureError, captureMessage };
